import * as actionTypes from '../actions/actionTypes';

const initialState = {
  speedCheckResults: [],
  speedCheckStartDate: null,
  routerSpeedCheckVisible: false,
  speedCheckResultsError: false,
  isResetFuncCalled: false,
  resultsLoading: false,
  resultsLoaded: false
};

const setSpeedCheckVisiblity = (state, { routerSpeedCheckVisible }) => ({
  ...state,
  routerSpeedCheckVisible,
})

const setSpeedCheckStartDate = (state, { speedCheckStartDate }) => ({
  ...state,
  speedCheckResultsError: false,
  speedCheckStartDate,
  isResetFuncCalled: false
})

const setSpeedCheckResults = (state, { speedCheckResults }) => ({
  ...state,
  speedCheckResults,
  speedCheckResultsError: false,
})

const setSpeedCheckFailed = (state, { speedCheckResultsError }) => ({
  ...state,
  speedCheckResults: null,
  speedCheckStartDate: null,
  speedCheckResultsError: true,
  resultsLoaded: true,
  resultsLoading: false

})

const resetSpeedCheckFlags = (state, action) => ({
  ...state,
  speedCheckStartDate: null,
  speedCheckResultsError: false,
  isResetFuncCalled: true,

})
const setResultsLoaded = (state, action) => ({
  ...state,
  resultsLoaded: action.val
})
const setResultsLoading = (state, action) => ({
  ...state,
  resultsLoading: action.val
})
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_RSC_START_TIME:
      return setSpeedCheckStartDate(state, action);
    case actionTypes.SET_RSC_RESULTS_SUCCESS:
      return setSpeedCheckResults(state, action);
    case actionTypes.SET_RSC_IS_AVAILABLE:
      return setSpeedCheckVisiblity(state, action);
    case actionTypes.SET_RSC_RESULTS_FAILED:
      return setSpeedCheckFailed(state, action);
    case actionTypes.RESET_RSC_FLAGS:
      return resetSpeedCheckFlags(state, action);
    case actionTypes.SET_RESULTS_LOADED:
      return setResultsLoaded(state, action);
    case actionTypes.SET_RESULTS_LOADING:
      return setResultsLoading(state, action);
    default:
      return state;
  }
};

export default reducer;
